import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'
import Text from '@/components-latest/primitives/Text'

import Styles from './ErrorState.module.scss'

interface IErrorStateProps {
  title?: string
  description?: string
  retryLabel?: string
  onRetry?: () => void
  isRetrying?: boolean
  className?: string
  'data-testid'?: string
}

/**
 * Shown whenever a fetch fails, so a transient network failure never leaves the
 * user in front of a spinner that will not resolve on its own.
 */
const ErrorState: React.FC<IErrorStateProps> = ({
  title,
  description,
  retryLabel,
  onRetry,
  isRetrying,
  className,
  'data-testid': testId = 'error-state'
}) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(Styles.errorState, className)} data-testid={testId}>
      <Text variant="title-3" gutter={8} align="center">
        {title || t('common.error-state.title')}
      </Text>
      <Text variant="subtitle" className={Styles.dimmed} align="center">
        {description || t('common.error-state.description')}
      </Text>
      {!!onRetry && (
        <Button
          variant="secondary"
          size="medium"
          className={Styles.retryButton}
          loading={isRetrying}
          onClick={onRetry}
          data-testid={`${testId}-retry`}>
          {retryLabel || t('common.error-state.retry')}
        </Button>
      )}
    </div>
  )
}

export type { IErrorStateProps }
export default ErrorState
